import './Home.css';
import { Link, NavLink } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';
import { useState, useEffect } from 'react';

export default function Home() {
  const { t, lang, toggleLanguage } = useLanguage();
  const [currentSlide, setCurrentSlide] = useState(0);

  const images = [
    'https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=1920&h=1080&fit=crop',
    'https://images.unsplash.com/photo-1546410531-bb4caa6b424d?w=1920&h=1080&fit=crop',
    'https://images.unsplash.com/photo-1427504494785-3a9ca7044f45?w=1920&h=1080&fit=crop',
    'https://images.unsplash.com/photo-1509062522246-3755977927d7?w=1920&h=1080&fit=crop'
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [images.length]);

  return (
    <div className="app">
      <header className="hero">
        <div className="hero-gallery-container">
          {images.map((img, index) => (
            <div
              key={index}
              className={`hero-slide ${index === currentSlide ? 'active' : ''}`}
              style={{ backgroundImage: `url(${img})` }}
            />
          ))}
          <div className="hero-overlay"></div>
        </div>
        
        <nav className="nav">
          <Link to="/" className="brand-link">
            <img
              src="/ceam-logo.png"
              className="brand-logo"
              alt="Centro Educativo Adventista de Monteverde"
            />
            <div className="brand-text">
              <span className="brand-title">{t('common.brand')}</span>
              <span className="brand-subtitle">{t('common.schoolName')}</span>
            </div>
          </Link>
          <div className="nav-actions">
            <NavLink to="/" className="btn ghost">{t('nav.home')}</NavLink>
            <NavLink to="/admisiones" className="btn ghost">{t('nav.admissions')}</NavLink>
            <NavLink to="/acerca-de" className="btn ghost">{t('nav.about')}</NavLink>
            <NavLink to="/ubicacion" className="btn ghost">{t('nav.contact')}</NavLink>
            <NavLink to="/voluntariado" className="btn ghost">{t('nav.volunteer')}</NavLink>
            <button type="button" className="btn ghost lang-toggle" onClick={toggleLanguage}>
              {lang === 'es' ? 'EN' : 'ES'}
            </button>
          </div>
        </nav>

        <div className="hero-content">
          <div className="hero-text">
            <p className="eyebrow">{t('home.eyebrow')}</p>
            <h1>{t('home.heroTitle')}</h1>
            <p className="lead">
              {t('home.heroLead')}
            </p>
            <div className="hero-actions">
              <a href="https://wa.me/50662857770" target="_blank" rel="noopener noreferrer" className="btn primary">{t('home.visit')}</a>
              <Link to="/admisiones" className="btn ghost">{t('home.viewLevels')}</Link>
            </div>
            <div className="stats">
              <div>
                <strong>25+</strong>
                <span>{t('home.years')}</span>
              </div>
              <div>
                <strong>50+</strong>
                <span>{t('home.students')}</span>
              </div>
              <div>
                <strong>9</strong>
                <span>{t('home.teachers')}</span>
              </div>
            </div>
          </div>
          <div className="hero-card">
            <h3>{t('home.heroCardTitle')}</h3>
            <p>{t('home.heroCardText')}</p>
            <ul>
              <li>{t('home.heroCardList1')}</li>
              <li>{t('home.heroCardList2')}</li>
              <li>{t('home.heroCardList3')}</li>
            </ul>
            <button className="btn dark" onClick={() => window.open('https://wa.me/50662857770', '_blank')}>{t('home.requestInfo')}</button>
          </div>
        </div>
      </header>

      <section className="section">
        <h2>{t('home.pillarsTitle')}</h2>
        <div className="grid">
          <article className="card">
            <h3>{t('home.pillar1Title')}</h3>
            <p>{t('home.pillar1Text')}</p>
          </article>
          <article className="card">
            <h3>{t('home.pillar2Title')}</h3>
            <p>{t('home.pillar2Text')}</p>
          </article>
          <article className="card">
            <h3>{t('home.pillar3Title')}</h3>
            <p>{t('home.pillar3Text')}</p>
          </article>
        </div>
      </section>

      <section className="section alt">
        <h2>{t('home.servicesTitle')}</h2>
        <div className="grid">
          <article className="card">
            <h3>{t('home.service1Title')}</h3>
            <p>{t('home.service1Text')}</p>
          </article>
          <article className="card">
            <h3>{t('home.service2Title')}</h3>
            <p>{t('home.service2Text')}</p>
          </article>
          <article className="card">
            <h3>{t('home.service3Title')}</h3>
            <p>{t('home.service3Text')}</p>
          </article>
        </div>
      </section>

      <footer className="footer">
        <p>{t('footer.rights')}</p>
      </footer>
    </div>
  );
}
